// A post carries an array of custom structured-data blocks (legacy posts: a single
// object). "Article" blocks override fields on the auto-generated article block (they
// share its @type) rather than being appended as separate, duplicate blocks; every
// other block is appended.
// ARTICLE_SCHEMA_TYPES must stay in sync with ARTICLE_TYPES in
// app/services/posts/structured_data_builder.rb.
const ARTICLE_SCHEMA_TYPES = ['Article', 'NewsArticle', 'BlogPosting'];

const isArticleBlock = (block: Record<string, unknown>) => {
  const blockType = block['@type'];
  return typeof blockType === 'string' && ARTICLE_SCHEMA_TYPES.includes(blockType);
};

export interface SplitCustomStructuredData {
  // Merged Article-family override fields, spread onto the auto-generated article block.
  articleOverride: Record<string, unknown>;
  // Non-article blocks, each emitted as its own JSON-LD script.
  appendedBlocks: Record<string, unknown>[];
}

const splitCustomStructuredData = (
  customStructuredData: Record<string, unknown>[] | Record<string, unknown> | null | undefined,
): SplitCustomStructuredData => {
  const blocks = Array.isArray(customStructuredData)
    ? customStructuredData
    : customStructuredData
      ? [customStructuredData]
      : [];

  return {
    articleOverride: Object.assign({}, ...blocks.filter(isArticleBlock)),
    appendedBlocks: blocks.filter((block) => !isArticleBlock(block)),
  };
};

export default splitCustomStructuredData;
